import { Form, Formik, FormikProps } from "formik";
import { Title } from "../../../../../stories/Title/Title";
import {
  empType,
  ItmsChallasEnum,
  Operation,
} from "../../../../../utils/Enum.types";
import LoadingModal from "../../../../pages/LoadingModal";

import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  AddItmsChallanResult,
  AddItmsChallanVars,
  CreateItmsChallansFormType,
  ItmsChallans,
  ItmsChallansOrderField,
  ItmsChallanType,
  OrderDirection,
  UpdateItmsChallanResult,
  UpdateItmsChallanVar,
} from "./queries/types";
import { LabelProps } from "../../../../../utils/types";
import useFormJson from "../../../../../json/useFormJson";
import { Button } from "../../../../../stories/Button/Button";
import MessageModal from "../../../../../customComponents/MessageModal";
import {
  DEFAULT_TIME,
  EMPTY_STRING,
  emptyMessage,
  ROWS_PER_PAGE,
} from "../../../../../utils/constants";
import { Label } from "../../../../../stories/Label/Label";
import InputNumber from "../../../../common/Input/InputNumber";
import {
  handleFormEvent,
  handleMUISelectEvent,
  toInputStandardDate,
  toIsoDate,
} from "../../../../../utils/UtilFunctions";
import InputHoc from "../../../../common/Input/Index";
import { useLazyQuery, useMutation } from "@apollo/client";
import { AddItmsChallan, UpdateItmsChallan } from "./queries/mutations";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import useServerDateandTime from "../../../../../customHooks/useServerDateandTime";
import { AppContext } from "../../../../../context/context";
import { nodeVar } from "../../../../../utils/commonQueryTypes";
import { GetItmsChallans, GetItmsChallansNode } from "./queries/queries";
import { TextField } from "@mui/material";
import Input from "../../../../../stories/Input/Input";
import dayjs from "dayjs";
import {
  FormAutocomplete,
  formClasses,
} from "../../../../../styles/AutocompleteStyles";
import { Keys } from "../../../../../utils/Enum.keys";
import { FilterFormDataType } from "./Index";

interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  operation: Operation;
  filterFormData: FilterFormDataType;
}

const AddItmsChallanPage = ({
  operation,
  setModalFlag,
  filterFormData,
}: Props) => {
  const { ItmsChallanFormLabels } = useFormJson();
  const { serverDate } = useServerDateandTime();
  const { user_details } = useLoggedInUserDetails();
  const [message, setMessage] = useState(emptyMessage);
  const [challanType, setChallanType] = useState("");

  const { customer_id } = useUrlParams();

  const { state, dispatch } = useContext(AppContext);

  // const priorityOptions = Object.values(PriorityEnum);
  const initialValues: CreateItmsChallansFormType = {
    date: "",
    stopLine: 0,
    seatBelt: 0,
    jumpingSignal: 0,
    tripleRide: 0,
    noHelmet: 0,
    overSpeed: 0,
    driverOnCall: 0,
  };

  const [formData, setFormData] =
    useState<CreateItmsChallansFormType>(initialValues);

  const [GetItmsChallansByNode, { loading: GetLoading }] = useLazyQuery<
    { node: ItmsChallans },
    nodeVar
  >(GetItmsChallansNode);

  const [Add, { loading: AddLoading }] = useMutation<
    AddItmsChallanResult,
    AddItmsChallanVars
  >(AddItmsChallan, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });
  const [UpdateItmsChallanDetails, { loading: UpdateLoading }] = useMutation<
    UpdateItmsChallanResult,
    UpdateItmsChallanVar
  >(UpdateItmsChallan, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const handleValueChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    meta: FormikProps<CreateItmsChallansFormType>,
  ) => {
    const { name, value } = e.target as HTMLInputElement;

    setFormData(() => ({
      ...formData,
      [name]: value,
    }));
    meta.handleChange(e);
  };

  const hanldeClear = () => {
    const inputElement = document.getElementsByName(
      "date",
    )[0] as HTMLInputElement;
    if (inputElement) inputElement.focus();
    setFormData(initialValues);
  };

  const handleClose = () => {
    setMessage(emptyMessage);
    if (message.operation !== Operation.NONE) {
      hanldeClear();
      setModalFlag(false);
    }
  };

  const handleSubmit = async () => {
    if (!challanType) {
      setMessage({
        flag: true,
        message: "Required challan type",
        operation: Operation.NONE,
      });
      return;
    }
    if (customer_id) {
      if (operation === Operation.CREATE) {
        const empAdded = Add({
          variables: {
            user_details,
            input: {
              date: toIsoDate(formData.date),
              stopLine: formData.stopLine,
              seatBelt: formData.seatBelt,
              jumpingSignal: formData.jumpingSignal,
              tripleRide: formData.tripleRide,
              noHelmet: formData.noHelmet,
              overSpeed: formData.overSpeed,
              driverOnCall: formData.driverOnCall,
              challanType: challanType as ItmsChallanType,
            },
            customer_id,
          },
          refetchQueries: [
            {
              query: GetItmsChallans,
              variables: {
                after: null,
                customer_id: customer_id ? customer_id : 0,
                first: ROWS_PER_PAGE,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: ItmsChallansOrderField.DATE,
                },
                startDate: filterFormData.fromDate
                  ? toIsoDate(filterFormData.fromDate)
                  : undefined,
                endDate: filterFormData.endDate
                  ? toIsoDate(filterFormData.endDate)
                  : undefined,
                name: EMPTY_STRING,
                challanTypeIn: [ItmsChallanType.BIAL, ItmsChallanType.ITMS],
              },
            },
          ],
        });
        const { data } = await empAdded;

        if (data && data.AddItmsChallan) {
          setMessage({
            flag: true,
            message: `added successfully`,
            operation: Operation.CREATE,
          });
        }
      } else {
        const junctionUpdated = UpdateItmsChallanDetails({
          variables: {
            user_details,
            input: {
              date: toIsoDate(formData.date),
              stopLine: formData.stopLine,
              seatBelt: formData.seatBelt,
              jumpingSignal: formData.jumpingSignal,
              tripleRide: formData.tripleRide,
              noHelmet: formData.noHelmet,
              overSpeed: formData.overSpeed,
              driverOnCall: formData.driverOnCall,
              challanType: challanType as ItmsChallanType,
            },
            itms_challan_id: state.ItmsChallanId,
          },
          refetchQueries: [
            {
              query: GetItmsChallans,
              variables: {
                after: null,
                customer_id: customer_id ? customer_id : 0,
                first: ROWS_PER_PAGE,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: ItmsChallansOrderField.DATE,
                },
                startDate: filterFormData.fromDate
                  ? toIsoDate(filterFormData.fromDate)
                  : undefined,
                endDate: filterFormData.endDate
                  ? toIsoDate(filterFormData.endDate)
                  : undefined,
                name: EMPTY_STRING,
                challanTypeIn: [ItmsChallanType.BIAL, ItmsChallanType.ITMS],
              },
            },
          ],
        });
        const { data } = await junctionUpdated;
        if (data && data.UpdateItmsChallan) {
          setMessage({
            flag: true,
            message: `updated successfully`,
            operation: Operation.CREATE,
          });
        }
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (state.ItmsChallanId && operation === Operation.UPDATE) {
        GetItmsChallansByNode({
          variables: {
            id: state.ItmsChallanId,
          },
        }).then(({ data }) => {
          if (data && data.node) {
            setFormData({
              id: data.node.id,
              date: toInputStandardDate(data.node.date),
              stopLine: data.node.stopLine,
              seatBelt: data.node.seatBelt,
              jumpingSignal: data.node.jumpingSignal,
              tripleRide: data.node.tripleRide,
              noHelmet: data.node.noHelmet,
              overSpeed: data.node.overSpeed,
              driverOnCall: data.node.driverOnCall,
              total: data.node.total,
              customerID: data.node.customerID,
            });
            setChallanType(data.node.challanType);
          }
        });
      }
    };
    fetchData();
  }, [GetItmsChallansByNode, operation]);

  useEffect(() => {
    if (serverDate)
      setFormData(() => ({
        ...formData,
        date: toInputStandardDate(serverDate),
      }));
  }, [serverDate]);

  const commonAutocompleteProps = {
    className: formClasses.inputRoot,
    options: Object.values(ItmsChallasEnum),
    openOnFocus: true,
  };

  const commonTextFieldProps = {
    fullWidth: true,
    className: formClasses.formControlRoot,
  };

  return (
    <>
      <Title>
        {operation === Operation.CREATE ? "Add " : "Edit "}
        ITMS Challan
      </Title>
      <Formik
        initialValues={formData}
        // validationSchema={junctoinLabel}
        onSubmit={handleSubmit}
        enableReinitialize
        validateOnChange
      >
        {(meta) => {
          return (
            <Form className="add-junctions">
              <div className="add-junctions__block">
                {ItmsChallanFormLabels.map(
                  (field: LabelProps, key: React.Key) => {
                    if (field.dataType === "date") {
                      if (operation === Operation.CREATE) {
                        return (
                          <React.Fragment key={key}>
                            <InputHoc
                              LabelName={field.labelName}
                              values={
                                formData[field.inputName] !== DEFAULT_TIME
                                  ? formData[field.inputName]
                                  : ""
                              }
                              name={field.inputName}
                              slotProps={{
                                inputLabel: { shrink: true },
                                input: {
                                  inputProps: {
                                    max: toInputStandardDate(serverDate),
                                  },
                                },
                              }}
                              onChange={(
                                e: React.ChangeEvent<HTMLInputElement>,
                              ) => {
                                if (
                                  dayjs(e.target.value).isAfter(
                                    dayjs(serverDate),
                                  )
                                ) {
                                  return;
                                }
                                handleValueChange(e, meta);
                              }}
                              required={field.required}
                              autoFocus={field.autoFocus}
                              type={field.dataType}
                            />
                            {meta.touched && meta.errors[field.inputName] ? (
                              <span className="nodata">
                                {meta.errors[field.inputName]}
                              </span>
                            ) : null}
                          </React.Fragment>
                        );
                      } else {
                        return (
                          <React.Fragment key={key}>
                            <div className="label-grid">
                              <Label>Date</Label>
                              <Input
                                value={
                                  formData[field.inputName] !== DEFAULT_TIME
                                    ? formData[field.inputName]
                                    : ""
                                }
                                disabled
                              />
                            </div>
                          </React.Fragment>
                        );
                      }
                    } else if (field.dataType === "challanType") {
                      return (
                        <React.Fragment key={key}>
                          <div className="label-grid">
                            <Label>{field.labelName}</Label>
                            <FormAutocomplete
                              {...commonAutocompleteProps}
                              value={challanType}
                              isOptionEqualToValue={(option) =>
                                (option as string) === challanType ||
                                challanType === EMPTY_STRING
                              }
                              onKeyDown={(e) => {
                                if (e.key === Keys.ENTER) {
                                  handleMUISelectEvent(e);
                                }
                              }}
                              onChange={(
                                e: React.SyntheticEvent<Element, Event>,
                                value: unknown,
                              ) => {
                                if (value) {
                                  setChallanType(value as string);
                                } else {
                                  setChallanType("");
                                }
                              }}
                              disabled={operation === Operation.UPDATE}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  {...commonTextFieldProps}
                                  autoFocus={true}
                                  autoComplete="one-time-code"
                                />
                              )}
                            />
                          </div>
                        </React.Fragment>
                      );
                    } else if (field.dataType === "number") {
                      return (
                        <React.Fragment key={key}>
                          <div className="label-grid">
                            <Label>{field.labelName}</Label>
                            <InputNumber
                              value={formData[field.inputName]}
                              onChange={(
                                e: React.ChangeEvent<HTMLInputElement>,
                              ) => {
                                handleValueChange(e, meta);
                              }}
                              onKeyDown={handleFormEvent}
                              name={field.inputName}
                              required={field.required}
                              maxLength={field.maxLength}
                            />
                            {meta.touched[field.inputName] &&
                            meta.errors[field.inputName] ? (
                              <div className="label-grid">
                                <span className="nodata">
                                  {meta.errors[field.inputName]}
                                </span>
                              </div>
                            ) : null}
                          </div>
                        </React.Fragment>
                      );
                    } else {
                      return (
                        <React.Fragment key={key}>
                          <InputHoc
                            LabelName={field.labelName}
                            values={formData[field.inputName]}
                            name={field.inputName}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>,
                            ) => {
                              handleValueChange(e, meta);
                            }}
                            required={field.required}
                            autoFocus={field.autoFocus}
                          />

                          {meta.touched[field.inputName] &&
                          meta.errors[field.inputName] ? (
                            <div className="label-grid">
                              <span></span>
                              <span className="nodata">
                                {meta.errors[field.inputName]}
                              </span>
                            </div>
                          ) : null}
                        </React.Fragment>
                      );
                    }
                  },
                )}
              </div>
              <Button mode="save" type="submit" />
              <Button mode="clear" type="button" onClick={hanldeClear} />
              <Button
                mode="cancel"
                onClick={() => {
                  setModalFlag(false);
                }}
              />
              <MessageModal
                handleClose={handleClose}
                modalFlag={message.flag}
                operation={message.operation}
                value={message.message}
              />
            </Form>
          );
        }}
      </Formik>
      <LoadingModal flag={GetLoading || AddLoading || UpdateLoading} />
    </>
  );
};

export default AddItmsChallanPage;
